import { createContext, useContext } from 'react';
import { ListReference, ModifierAndCreatorById } from '../../domain';

export type ListUsageQueryContextState = {
  isLoading: boolean;
  isError: boolean;
  listReferences: ListReference[];
  totalCount: number;
  modifiersAndCreatorsById: ModifierAndCreatorById;
};

export const defaultState = {
  isLoading: false,
  isError: false,
  listReferences: [],
  totalCount: 0,
  modifiersAndCreatorsById: {},
};

export const ListUsageQueryContext = createContext<ListUsageQueryContextState>(defaultState);

export const useListUsageQueryContext = () => useContext(ListUsageQueryContext);
